import { useQuery } from '@tanstack/react-query';

import { getReasonReportListing } from './listing.api';

export const REASON_REPORT_LISTING_QUERY_KEY = 'reason-report-listing';

export const useReasonReportListing = () =>
  useQuery({
    queryKey: [REASON_REPORT_LISTING_QUERY_KEY],
    queryFn: getReasonReportListing,
  });
